import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableDataTypeState } from "./initializes";
import type { TableDataType, attachLoadingType, attachErrorType } from "./types";

const tableDataTypeSlice = createSlice({
  name: "TableDataType",
  initialState: initialTableDataTypeState,
  reducers: {
    setMemberSelections: (state: TableDataType, action: PayloadAction<object[]>) => {
      state.memberSelections = action.payload;
    },
    setImageAttachLoading: (state: TableDataType, action: PayloadAction<attachLoadingType>) => {
      state.imageAttachLoading = action.payload;
    },
    setImageAttachError: (state: TableDataType, action: PayloadAction<attachErrorType>) => {
      state.imageAttachError = action.payload;
    },
    setFileAttachLoading: (state: TableDataType, action: PayloadAction<attachLoadingType>) => {
      state.fileAttachLoading = action.payload;
    },
    setFileAttachError: (state: TableDataType, action: PayloadAction<attachErrorType>) => {
      state.fileAttachError = action.payload;
    },
  },
});

export const {
  setMemberSelections,
  setImageAttachLoading,
  setImageAttachError,
  setFileAttachLoading,
  setFileAttachError,
} = tableDataTypeSlice.actions;

export default tableDataTypeSlice.reducer;
